(function () {
    var controllerId = 'host.views.corporates.masterPolicies.masterPolicy.createEditMasterPolicy';
    var app = angular.module('app');
    app.controller(controllerId, [
        function () {
            // Component class for create master policy container.
        }
    ]);
})();
